import React, { useState, useEffect } from 'react';
import { useTheme, makeStyles } from '@material-ui/core/styles'
import { Box, CircularProgress, List, ListItem, Typography, Button, TextField, DialogContent, Paper } from '@material-ui/core'
import { useTranslate, useDataProvider, Loading, usePermissions } from 'react-admin';
import { useHistory, useLocation } from 'react-router-dom';
import ConfirmDialog from '../CustomizedUIs/confirmDialog';
import { Add, Clear, Close, Create, DeleteOutline } from '@material-ui/icons'
import CreateRelative from './create'
import Snackbar from '../common/snackbar';
import icArrowUp from '../assets/icons/white-arrow-up.png';
import icArrowDown from '../assets/icons/white-arrow-down.png';
import Checkbox from '../checkbox'
import Search from '../search'
import { StyledButton } from '../common/table/index'
import DeleteButton from '../CustomizedUIs/DeleteButton';
import CustomPopoverArrow from '../CustomizedUIs/CustomPopoverArrow';
import { usePopupState, bindToggle } from 'material-ui-popup-state/hooks';
import EditRelative from './edit'
const useStyles = makeStyles(theme => ({
    tableSortLabel: {
        color: 'theme.palette.common.white',
        '&:hover': {
            color: 'white'
        },
        '&:focus': {
            color: 'white'
        },
    },
    textEdit: {
        fontFamily: 'UniviaPro',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
    dialogContent: {
        padding: '20px 8px !important'
    },
    icons: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 7,
        cursor: 'pointer'
    },
    icon: {
        width: 9,
        height: 9
    },
    subText: {
        fontFamily: 'UniviaPro-Medium',
        fontWeight: '500',
        lineHeight: "13.2px",
        marginLeft: 10,
        letterSpacing: 'normal',
        color: '#88898c',
        fontSize: 11
    }
}));


const Relatives = (props) => {
    const dataProvider = useDataProvider()
    const classes = useStyles()
    const translate = useTranslate()
    const [data, setData] = useState([])
    const [click, SetClick] = useState({ userName: false, isSuperUser: false, email: false, status: false })
    const { permissions, loaded } = usePermissions();
    const popupState = usePopupState({ variant: 'popper', popupId: 'delete' });
    const [openConfirmDialog, setOpenConfirmDialog] = useState({
        status: false,
        index: -1
    })
    const [loading, setLoading] = useState(false)
    const [showSnackbar, setShowSnackbar] = useState({ status: false })
    const [itemData, setItemData] = useState({})
    const [filter, setFilter] = useState('')
    const [dataFilter, setDataFilter] = useState([])
    const [creating, setCreating] = useState(false)
    const [assigning, setAssigning] = useState(false)
    const [editing, setEditing] = useState({
        status: false
    })

    const location = useLocation();
    const theme = useTheme()

    const getList = () => {
        setLoading(true)
        setFilter("")
        dataProvider('GET_LIST', "relatives/getfromroom", {
            filter: {
                room: props.data.id
            },
            pagination: {
                page: 1,
                perPage: -1
            },
            sort: { field: 'createdAt', order: 'ASC' },

        })
            .then(({ data }) => {
                if (data) {
                    setData(data);
                    data.forEach((item, index) => {
                        if (item.status === 1)
                            sendMail(data, item.id, index)
                    })
                }
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            })
    }

    const sendMail = (datas, id, index) => {
        dataProvider('CREATE', "relatives/registryemail", {
            data: {
                relativeAppLink: process.env.REACT_APP_RELATIVE_URL,
                relativeid: id
            }
        }).then(() => {
            let temps = [...datas]
            temps[index].status = 2
            setData(temps)
        })
    }

    useEffect(() => {
        console.log(creating, editing)
        if (!creating && !editing.status && !assigning)
            getList()
    }, [creating, editing, assigning])

    const onCancel = (index) => {
        let temps = data.slice()
        temps[index].edit = false
        delete temps[index].editName
        setData(temps)
    }

    const onClick = (prop) => {
        let temps = [...data]
        console.log(temps)
        temps.sort((a, b) => {
            var x, y
            x = typeof a[prop] === 'string' ? a[prop].toLowerCase() : a[prop];
            y = typeof b[prop] === 'string' ? b[prop].toLowerCase() : b[prop];
            if (x < y) { return click[prop] ? -1 : 1; }
            if (x > y) { return click[prop] ? 1 : -1; }
            return 0
        })
        setData(temps)
        SetClick({ ...click, [prop]: !click[prop] })
    }

    const handleOnDelete = () => {
        if (openConfirmDialog.index > -1 && openConfirmDialog.isDelete) {
            dataProvider('DELETE', "relatives", {
                id: openConfirmDialog.index
            })
                .then((response) => {
                    getList()
                    setShowSnackbar({
                        status: true,
                        name: data[openConfirmDialog.index].email,
                        message: translate(`pos.relatives.deleteRelative.success`)

                    })
                    setTimeout(() => setShowSnackbar({ status: false }), 6000)
                    setOpenConfirmDialog({ status: false, index: -1 })
                })
                .catch(error => {
                    setOpenConfirmDialog({ status: false, index: -1 })
                })
        }
    }

    const handleOnUnassign = () => {
        if (openConfirmDialog.index > -1 && !openConfirmDialog.isDelete) {
            dataProvider('UPDATE', "relatives/unassign", {
                id: openConfirmDialog.index,
                data: {
                    room: props.data.id
                }
            })
                .then((response) => {
                    getList()
                    setShowSnackbar({
                        status: true,
                        name: data[openConfirmDialog.index].email,
                        message: translate(`pos.relatives.unAssignRelative.success`)

                    })
                    setTimeout(() => setShowSnackbar({ status: false }), 6000)
                    setOpenConfirmDialog({ status: false, index: -1 })
                })
                .catch(error => {
                    setOpenConfirmDialog({ status: false, index: -1 })
                })
        }
        else {
            var requests = []
            dataFilter.forEach(element => {
                element.checked && requests.push(
                    dataProvider('DELETE', "firmware", {
                        id: element.id
                    })
                )
            })
            if (requests.length > 0) {
                Promise.all(requests).then(() => {
                    getList()
                    setOpenConfirmDialog({ status: false, index: -1 })
                }).catch(error => {
                    setOpenConfirmDialog({ status: false, index: -1 })
                });
            }
            else
                setOpenConfirmDialog({ status: false, index: -1 })

        }

    }

    const onClear = () => {
        let temps = dataFilter.slice()
        temps.map(item => {
            delete item.checked
            return item
        })
        setDataFilter(temps)
    }


    const submitFilter = () => {
        setDataFilter(data.filter(item => item.firmware.name.toUpperCase().includes(filter.toUpperCase())
            || item.model.name.toString().toUpperCase().includes(filter.toUpperCase())
            || item.version.toString().toUpperCase().includes(filter.toUpperCase())
        ))
    }
    const handleOpenPopup = (dialogData) => {
        setOpenConfirmDialog(dialogData)
        popupState.close()

    }


    if (creating) return <CreateRelative setCreating={setCreating} data={props.data} setShowSnackbar={setShowSnackbar} super={data.length === 0} />
    if (assigning) return <CreateRelative setCreating={setAssigning} data={props.data} setShowSnackbar={setShowSnackbar} super={data.length === 0} assign={true} />
    if (editing.status) return <EditRelative setEditing={setEditing} roomId={props.data.id} data={editing.data} setShowSnackbar={setShowSnackbar} super={data.filter((item) => item.role?.includes('super_user')).length > 0} />
    if (loading || !loaded) return <Loading />
    return (
        <Box width='100%' display='flex' justifyContent='center'>
            <Box width='60%'>
                <Box width='100%' display='flex' justifyContent='flex-end' mt={2}>

                    <Snackbar
                        show={showSnackbar.status}
                        boldText={showSnackbar.name || ""}
                        message={showSnackbar.message || ""}
                        onClose={() => setShowSnackbar({ status: false })}
                    />

                </Box>
                <Box width='100%' display='flex' alignItems='center'>
                    <Box flexGrow={1} display="flex" flexDirection="row" alignItems="center" >
                        <Typography variant='h5' style={{ fontFamily: 'UniviaPro-Medium', lineHeight: '21.6px', color: '#4f5064', fontWeight: 500 }}>{translate(`pos.user.name`)}</Typography>
                    </Box>
                    <Search
                        disableButton={true}
                        placeholder={translate(`pos.user.search`)}
                        onChangeText={setFilter}
                        getList={submitFilter}
                    />
                    {
                        // permissions.functionAction.find(value => value.function === 'Remote FirmWare' && value.isUpdate) &&
                        <Box ml={4} display='flex'>
                            <Button variant='contained' color='primary' onClick={() => setCreating(true)}>
                                <Typography style={{ fontSize: '9px', lineHeight: '11px', letterSpacing: '0.36px', fontFamily: 'UniviaPro-Bold' }}>{translate(`pos.user.create`)}</Typography>

                                <Add />
                            </Button>
                            {
                                !data.some(item => item.isBokamera) &&  <Button variant='contained' color='primary' style={{ marginLeft: 8 }} onClick={() => setAssigning(true)}>
                                <Typography style={{ fontSize: '9px', lineHeight: '11px', letterSpacing: '0.36px', fontFamily: 'UniviaPro-Bold' }}>{translate(`resources.room.assignRelative`)}</Typography>

                            </Button>
                            }
                        </Box>
                    }

                </Box>
                <Box>
                    <Box display='flex' px={3} py={2} mb={2} mt={1} bgcolor={theme.palette.primary.main}>
                        <Box flexGrow={1} display='flex' alignItems='center'>
                            {
                                dataFilter.filter(item => item.checked).length > 0 ?
                                    <Box display='flex' justifyContent='space-between' width='100%' style={{ pointerEvents: permissions.functionAction.find(value => value.function === 'Remote FirmWare' && value.isUpdate) ? 'auto' : 'none' }}>
                                        <StyledButton
                                            onClick={() => {
                                                setOpenConfirmDialog({
                                                    status: true,
                                                    index: -1
                                                })
                                            }}
                                            variant='text'
                                            startIcon={<DeleteOutline />}
                                        >
                                            {translate(`pos.common.delete`)}
                                        </StyledButton>
                                        <StyledButton
                                            onClick={onClear}
                                            variant='text'
                                            startIcon={<Clear />}
                                        >{dataFilter.filter(item => item.checked).length} {dataFilter.filter(item => item.checked).length > 1 ? translate('pos.categories.filesSelected') : translate('pos.categories.fileSelected')}</StyledButton>
                                    </Box>
                                    :
                                    <Box width='100%' display='flex'>
                                        <Box display='flex' width={200}>
                                            <Typography
                                                style={{ cursor: 'pointer', color: 'white', fontSize: '13px', lineHeight: '16.3px', letterSpacing: '0.13px', fontFamily: 'UniviaPro' }}
                                                variant='body1'>
                                                Name
                                            </Typography>
                                            <div className={classes.icons} onClick={() => onClick('userName')}>
                                                <img alt='Up arrow' src={icArrowUp} className={classes.icon} style={{ opacity: click.userName === true ? 0 : 1 }} />
                                                <img alt='Down arrow' src={icArrowDown} className={classes.icon} style={{ opacity: click.userName === false ? 0 : 1 }} />
                                            </div>
                                        </Box>
                                        <Box display='flex' width={100}>
                                            <Typography
                                                style={{ cursor: 'pointer', color: 'white', fontSize: '13px', lineHeight: '16.3px', letterSpacing: '0.13px', fontFamily: 'UniviaPro' }}
                                                variant='body1'>
                                                Role
                                            </Typography>
                                            <div className={classes.icons} onClick={() => onClick('isSuperUser')} role>
                                                <img alt='Up arrow' src={icArrowUp} className={classes.icon} style={{ opacity: click.isSuperUser === true ? 0 : 1 }} />
                                                <img alt='Down arrow' src={icArrowDown} className={classes.icon} style={{ opacity: click.isSuperUser === false ? 0 : 1 }} />
                                            </div>
                                        </Box>
                                        <Box display='flex' width={250}>
                                            <Typography
                                                style={{ cursor: 'pointer', color: 'white', fontSize: '13px', lineHeight: '16.3px', letterSpacing: '0.13px', fontFamily: 'UniviaPro' }}
                                                variant='body1'>
                                                E-mail
                                            </Typography>
                                            <div className={classes.icons} onClick={() => onClick('email')} >
                                                <img alt='Up arrow' src={icArrowUp} className={classes.icon} style={{ opacity: click.email === true ? 0 : 1 }} />
                                                <img alt='Down arrow' src={icArrowDown} className={classes.icon} style={{ opacity: click.email === false ? 0 : 1 }} />
                                            </div>
                                        </Box>
                                        <Box display='flex' width={300}>
                                            <Typography
                                                style={{ cursor: 'pointer', color: 'white', fontSize: '13px', lineHeight: '16.3px', letterSpacing: '0.13px', fontFamily: 'UniviaPro' }}
                                                variant='body1'>
                                                Status
                                            </Typography>
                                            <div className={classes.icons} onClick={() => onClick('status')}>
                                                <img alt='Up arrow' src={icArrowUp} className={classes.icon} style={{ opacity: click.status === true ? 0 : 1 }} />
                                                <img alt='Down arrow' src={icArrowDown} className={classes.icon} style={{ opacity: click.status === false ? 0 : 1 }} />
                                            </div>
                                        </Box>

                                    </Box>
                            }

                        </Box>
                    </Box>
                    <Box height='400px' style={{ overflow: 'auto' }}>
                        {
                            data
                                .filter((item) =>
                                    item.name.toLowerCase().includes(filter.toLowerCase())
                                    || item.email.toLowerCase().includes(filter.toLowerCase())
                                    || `${item.role?.includes('super_user') ? 'super user' : 'user'}`.includes(filter.toLowerCase())
                                )
                                .map((item, index) => (
                                    item && <Box key={'channel' + index} display='flex' px={3} py={2} mt={1} bgcolor='white'>
                                        <Box flexGrow={1} display='flex' alignItems='center'>
                                            <Box flexGrow={1} display='flex' alignItems='center'>
                                                <Box display='flex' width={200} whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis' >
                                                    <Typography style={{ cursor: 'pointer', letterSpacing: 'normal', fontFamily: 'UniviaPro-Book' }} >{item.name}</Typography>
                                                </Box>

                                                <Box display='flex' width={100} whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis' >
                                                    <Typography
                                                        style={{ textDecorationLine: 'none', letterSpacing: 'normal', fontFamily: 'UniviaPro-Book' }}
                                                        variant='body1'>
                                                        {item.role?.includes('super_user') ? "Super user" : "User"}
                                                    </Typography>
                                                </Box>

                                                <Box display='flex' width={250} whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis'>
                                                    <Typography

                                                        style={{ cursor: 'pointer', color: item.status === 1 ? 'red' : item.status === 2 ? '#e1800b' : theme.palette.primary.main, textDecorationLine: 'none', letterSpacing: 'normal', fontFamily: 'UniviaPro-Book' }}
                                                        variant='body1' color='primary'>
                                                        {item.email}
                                                    </Typography>
                                                </Box>

                                                <Box display='flex' width={300} whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis'>
                                                    <Typography
                                                        style={{ cursor: 'pointer', color: item.status === 1 ? 'red' : item.status === 2 ? '#e1800b' : theme.palette.primary.main, textDecorationLine: 'none', letterSpacing: 'normal', fontFamily: 'UniviaPro-Book' }}
                                                        variant='body1' color='primary'>
                                                        {item.status === 1 ? "Awaiting connection" : item.status === 2 ? "Awaiting Reply" : "Offline"}
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            <Box display='flex' justifyContent='flex-end' alignItems='center' width='auto'>
                                                <Button
                                                    style={{ marginRight: 8 }}
                                                    variant="contained"
                                                    color='primary'
                                                    size='small'
                                                    onClick={() => setEditing({ status: true, data: item })}
                                                >
                                                    <Typography className={classes.textEdit} style={{ padding: '8px' }}>{translate(`pos.user.edituser`)} </Typography>
                                                </Button>
                                                <DeleteButton
                                                    bgColor={theme.palette.grey.A700}
                                                    border='none'
                                                    onClick={(e) => {
                                                        popupState.setAnchorEl(e.target);
                                                        popupState.open();
                                                        setItemData(item)
                                                    }}
                                                />
                                                <CustomPopoverArrow
                                                    zIndex={99999}
                                                    popupState={popupState}
                                                    placement='right-start'
                                                >
                                                    <Paper>
                                                        <List>
                                                            <ListItem button onClick={() => {
                                                                if (Object.keys(itemData).length > 0) {
                                                                    handleOpenPopup({ status: true, index: itemData.id, isDelete: false })
                                                                }
                                                            }}>Unassign from room</ListItem>
                                                            <ListItem button onClick={() => {
                                                                if (Object.keys(itemData).length > 0) {
                                                                    handleOpenPopup({ status: true, index: itemData.id, isDelete: true })
                                                                }
                                                            }}>Delete</ListItem>
                                                        </List>
                                                    </Paper>

                                                </CustomPopoverArrow>
                                            </Box>

                                        </Box>


                                    </Box>
                                ))
                        }
                    </Box>
                </Box>
            </Box>
            <ConfirmDialog
                open={openConfirmDialog.status}
                handleClose={() => { setOpenConfirmDialog({ status: false, index: -1 }) }}
                handleConfirm={openConfirmDialog.isDelete ? handleOnDelete : handleOnUnassign}
                ContentText={translate('pos.user.contentDelete')}
                Tittle={openConfirmDialog.isDelete ? translate('pos.deviceFirmware.delete') : translate(`pos.devices.unassginFromRoom`)} />
            {/* 
            <Dialog open={showMessagePopup} scroll='paper'>
                <Box display='flex' justifyContent='flex-end' alignContent='center' mr={2} mt={2}>
                    <IconRadiusButton onClick={onCloseMessagePopup}>
                        <Close color='primary' />
                    </IconRadiusButton>
                </Box>
                <DialogContent>
                    <Box mx={2.5} className={classes.dialogContent}>
                        {messagePopupContent}
                    </Box>
                </DialogContent>
            </Dialog> */}
        </Box>
    )
}
export default Relatives